import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import BreederProfileLittersAndPuppiesTabContainer from 'dpl/containers/BreederProfile/Show/BreederProfileLittersAndPuppiesTabContainer';
import BreederProfileOverviewTabContainer from 'dpl/containers/BreederProfile/Show/BreederProfileOverviewTabContainer';
import BreederProfileOwnerStoriesTabContainer from 'dpl/containers/BreederProfile/Show/BreederProfileOwnerStoriesTabContainer';
import BreederProfileUpdatesTabContainer from 'dpl/containers/BreederProfile/Show/BreederProfileUpdatesTabContainer';
import { trackPageView } from 'dpl/util/analytics';

import BreederProfileOverviewTab from '../../mobile/components/overview/BreederProfileOverviewTab';
import BreederProfileAboutTab from '../../mobile/components/about/BreederProfileAboutTab';
import BreederProfileReviews from '../../mobile/components/reviews/BreederProfileReviews';
import useBreederProfileTabs from '../../hooks/useBreederProfileTabs';
import {
  PAGE_CATEGORIES,
  MOBILE_PAGE_CATEGORIES,
  TAB_KEYS,
  MOBILE_TAB_KEYS
} from '../../utils/constants';
import useBreederProfileMobileLayout from '../../hooks/useBreederProfileMobileLayout';

export default function BreederProfileTabContent() {
  const { activeTabKey } = useBreederProfileTabs();
  const { isNewMobileLayout } = useBreederProfileMobileLayout();

  const { analyticsPageName, breederProfileId } = useSelector(
    ({ server }) => server
  );

  const tabContent = {
    [TAB_KEYS.OVERVIEW]: BreederProfileOverviewTabContainer,
    [TAB_KEYS.DOGS]: BreederProfileLittersAndPuppiesTabContainer,
    [TAB_KEYS.UPDATES]: BreederProfileUpdatesTabContainer,
    [TAB_KEYS.STORIES]: BreederProfileOwnerStoriesTabContainer
  };

  const mobileTabContent = {
    [MOBILE_TAB_KEYS.OVERVIEW]: BreederProfileOverviewTab,
    [MOBILE_TAB_KEYS.ABOUT]: BreederProfileAboutTab,
    [MOBILE_TAB_KEYS.STORIES]: BreederProfileReviews,
    [MOBILE_TAB_KEYS.UPDATES]: BreederProfileUpdatesTabContainer
  };

  const pageCategories = isNewMobileLayout
    ? MOBILE_PAGE_CATEGORIES
    : PAGE_CATEGORIES;

  const TabContent = isNewMobileLayout
    ? mobileTabContent[activeTabKey]
    : tabContent[activeTabKey];

  useEffect(() => {
    trackPageView({
      name: analyticsPageName,
      category: pageCategories[activeTabKey],
      properties: { breeder_profile_id: breederProfileId }
    });
  }, [activeTabKey]);

  return <TabContent />;
}
